import { cx } from '@linaria/core';

import { SizeCommonButtonBase } from '../ButtonBase/SizeCommonButtonBase';
import type { SizeButtonBaseProps } from '../ButtonBase/types';
import { styledButton } from './styles';

export const ButtonPrimary = ({
	className,
	color = 'default',
	...props
}: SizeButtonBaseProps & { color?: 'default' | 'pink' }) => (
	<SizeCommonButtonBase
		className={cx(
			className,
			styledButton,
			color !== 'default' && `color-${color}`
		)}
		{...props}
	/>
);
